export interface DashboardNegocio {
  negocioId: number;
  nombreNegocio: string;
  empresaId: number;
  nombreEmpresa: string;
  totalPedidos: number;
  totalVentas: number;
  promedioTicket: number;
  pendientes: number;
  preparando: number;
  enCamino: number;
  entregados: number;
  cancelados: number;
}

export interface DashboardEmpresa {
  empresaId: number;
  nombreEmpresa: string;
  totalNegocios: number;
  totalPedidos: number;
  totalVentas: number;
  promedioTicket: number;
  pendientes: number;
  preparando: number;
  enCamino: number;
  entregados: number;
  cancelados: number;
}

export interface DashboardDiario {
  fecha: string;
  totalPedidos: number;
  totalVentas: number;
}

export interface DashboardResumen {
  totalPedidos: number;
  totalVentas: number;
  promedioTicket: number;
  totalEnvios: number;
  totalTarifaServicio: number;
  pedidosPendientes: number;
  pedidosPreparando: number;
  pedidosEnCamino: number;
  pedidosEntregados: number;
  pedidosCancelados: number;
  porNegocio: DashboardNegocio[];
  porEmpresa: DashboardEmpresa[];
  ventasDiarias: DashboardDiario[];
}

class DashboardService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_API_BASE_URL || 'https://localhost:7123/api';
  }

  private getHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    const token = localStorage.getItem('authToken');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return headers;
  }

  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`;

    const response = await fetch(url, {
      ...options,
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({
        message: 'Error en la conexión con el servidor',
      }));
      throw new Error(errorData.message || `Error HTTP: ${response.status}`);
    }

    return response.json();
  }

  async getResumen(empresaId?: number, periodo: string = 'todo'): Promise<DashboardResumen> {
    const params = new URLSearchParams();
    if (empresaId) params.append('empresaId', empresaId.toString());
    params.append('periodo', periodo);
    const qs = params.toString();
    return this.request<DashboardResumen>(`/dashboard${qs ? '?' + qs : ''}`);
  }
}

export const dashboardService = new DashboardService();
